/**
 * User Service
 *
 * API functions for user profile operations.
 */

import { apiClient } from "./api";
import type { ProfileOptions, User, UserUpdate } from "../types/user";

const API_PREFIX = import.meta.env.VITE_API_V1_PREFIX || "/api/v1";

export async function getCurrentUser(): Promise<User> {
  const response = await apiClient.get<User>(`${API_PREFIX}/users/me`);
  return response.data;
}

export async function updateCurrentUser(data: UserUpdate): Promise<User> {
  const response = await apiClient.patch<User>(`${API_PREFIX}/users/me`, data);
  return response.data;
}

export async function deleteAccount(
  confirmation: string
): Promise<{ message: string; summary: Record<string, unknown> }> {
  const response = await apiClient.delete<{
    message: string;
    summary: Record<string, unknown>;
  }>(`${API_PREFIX}/users/me`, { data: { confirmation } });
  return response.data;
}

export async function getProfileOptions(): Promise<ProfileOptions> {
  const response = await apiClient.get<ProfileOptions>(
    `${API_PREFIX}/users/profile-options`
  );
  return response.data;
}
